import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  public transform(items: Array<any>, term: string, field: string = 'value') {
    if (!term || !items) return items;
    return this.filterItems(items, term, field);
  }

  private filterItems(items: Array<any>, term: string, field: string) {
    const compareStr = term.toLowerCase();
    return items.filter(item => {
      if (!item || item[field] === undefined || item[field] === null) {
        return false;
      }
      return item[field]
        .toString()
        .toLowerCase()
        .includes(compareStr);
    });
  }
}
